"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivationCodeAuthSuiteService = void 0;
var tslib_1 = require("tslib");
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../../models");
var error_response_1 = require("../error-response");
var model_1 = require("./model");
var dowhile_1 = require("./dowhile");
var timeinterval_1 = require("./timeinterval");
var ActivationCodeAuthSuiteService = /** @class */ (function () {
    function ActivationCodeAuthSuiteService() {
        var _this = this;
        this.generate = function (_a) {
            var _b = _a.mvpdCode, mvpdCode = _b === void 0 ? null : _b, _c = _a.secondScreenEntryPoint, secondScreenEntryPoint = _c === void 0 ? null : _c, _d = _a.activationFlow, activationFlow = _d === void 0 ? model_1.ActivationFlow.SignIn : _d;
            var payload = {
                mvpdCode: mvpdCode,
                secondScreenEntryPoint: secondScreenEntryPoint,
                activationFlow: activationFlow,
            };
            var body = JSON.stringify(payload);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
                body: body,
                path: "access/activationCode",
            });
        };
        this.checkActivationCode = function (request) {
            return _this.getActivationCodeStatus(request, [models_1.AuthSuiteRequestParams.LogoSchema]);
        };
        this.checkActivationCodeStatusChange = function (request, activationFlow, statusChangeCallback) {
            if (activationFlow === void 0) { activationFlow = model_1.ActivationFlow.SignIn; }
            if (statusChangeCallback === void 0) { statusChangeCallback = null; }
            var timeoutInMs = new timeinterval_1.TimeInterval({
                minutes: request.checkActivationCodeStatusChangeTimeoutInMinutes || 5,
            }).inMilliseconds();
            var createFunction = activationFlow === model_1.ActivationFlow.SignIn
                ? _this.createActivationCodeStatusPoolingWrapperForSignInFLow
                : _this.createActivationCodeStatusPoolingWrapperForSubscriptionFlow;
            var poolingActivationCodeStatus = createFunction(request.waitWithLastKnownStatus, timeoutInMs, statusChangeCallback);
            return poolingActivationCodeStatus(request).catch(function (error) {
                throw _this.handleError(error);
            });
        };
        this.joinWithActivationCode = function (activationCode) {
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
                path: "access/activationCode/".concat(activationCode, "/join"),
                request: null,
                requestParams: [],
            });
        };
        this.createActivationCodeStatusPoolingWrapperForSignInFLow = function (currentStatus, timeoutInMs, statusChangeCallback) {
            return dowhile_1.DoWhile.create(function (request) {
                return _this.getActivationCodeStatus(request, [
                    models_1.AuthSuiteRequestParams.LogoSchema,
                    models_1.AuthSuiteRequestParams.WaitWithLastKnownStatus,
                ]);
            }, {
                timeoutInMs: timeoutInMs,
                intervalsInMs: new timeinterval_1.TimeInterval({ seconds: 1 }).inMilliseconds(),
                renewRequest: function (request, response) { return (tslib_1.__assign(tslib_1.__assign({}, request), { waitWithLastKnownStatus: response.signInStatus })); },
                breakCondition: function (response) {
                    var signInStatus = response.signInStatus;
                    if (statusChangeCallback !== null && currentStatus !== signInStatus) {
                        statusChangeCallback(signInStatus);
                    }
                    return ActivationCodeAuthSuiteService.FINAL_SIGN_IN_STATUSES_FOR_SIGN_IN_FLOW.indexOf(signInStatus) > -1;
                },
            });
        };
        this.createActivationCodeStatusPoolingWrapperForSubscriptionFlow = function (currentStatus, timeoutInMs, statusChangeCallback) {
            return dowhile_1.DoWhile.create(function (request) {
                return _this.getActivationCodeStatus(request, [
                    models_1.AuthSuiteRequestParams.LogoSchema,
                    models_1.AuthSuiteRequestParams.WaitWithLastKnownStatus,
                ]);
            }, {
                timeoutInMs: timeoutInMs,
                intervalsInMs: new timeinterval_1.TimeInterval({ seconds: 1 }).inMilliseconds(),
                renewRequest: function (request, response) { return (tslib_1.__assign(tslib_1.__assign({}, request), { waitWithLastKnownStatus: response.status })); },
                breakCondition: function (response) {
                    var status = response.status;
                    if (statusChangeCallback !== null && currentStatus !== status) {
                        statusChangeCallback(status);
                    }
                    return ActivationCodeAuthSuiteService.FINAL_STATUSES_FOR_SUBSCRIPTION_FLOW.indexOf(status) > -1;
                },
            });
        };
        this.getActivationCodeStatus = function (request, requestParams) {
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
                path: "access/activationCode/".concat(request.activationCode),
                request: request,
                requestParams: requestParams,
            });
        };
    }
    ActivationCodeAuthSuiteService.prototype.handleError = function (error) {
        if (error === dowhile_1.DoWhile.TIMEOUT_ERROR) {
            return error_response_1.authSuiteErrorFactory.createError(error_response_1.MethodErrorResponse.GET_USER_DETAILS_FROM_ACCESS_METHOD);
        }
        return error;
    };
    ActivationCodeAuthSuiteService.FINAL_STATUSES_FOR_SUBSCRIPTION_FLOW = [
        model_1.SignInAndSubscriptionPurchaseProcessStatus.Succeeded,
        model_1.SignInAndSubscriptionPurchaseProcessStatus.Failed,
    ];
    ActivationCodeAuthSuiteService.FINAL_SIGN_IN_STATUSES_FOR_SIGN_IN_FLOW = [
        model_1.SignInStatus.Succeeded,
        model_1.SignInStatus.Failed,
        model_1.SignInStatus.Cancelled,
    ];
    return ActivationCodeAuthSuiteService;
}());
exports.ActivationCodeAuthSuiteService = ActivationCodeAuthSuiteService;
